import React, { useEffect, useState } from "react";
import { CheckCircle, AlertCircle, Loader2 } from "lucide-react";
import "./AdminFees.css";

const API_URL = "https://www.fro.ro/api/admins/taxe-anuale.php";
const token = localStorage.getItem("adminToken");

export default function AdminFees() {
  const [fees, setFees] = useState([]);
  const [form, setForm] = useState({
    an: new Date().getFullYear(),
    taxa_sportiv1: "",
    taxa_sportiv2: "",
    taxa_sportiv3: "",
    taxa_arbitru1: "",
    taxa_arbitru2: "",
    taxa_arbitru3: "",
    taxa_antrenor: "",
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  const fetchFees = async () => {
    try {
      const res = await fetch(API_URL, { headers: { Authorization: `Bearer ${token}` } });
      const data = await res.json();
      setFees(data);
    } catch {
      setMessage({ type: "error", text: "Eroare la încărcarea taxelor." });
    }
  };

  useEffect(() => {
    fetchFees();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);

    try {
      const res = await fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (data.success || res.ok) {
        setMessage({ type: "success", text: "✅ Taxele au fost salvate!" });
        fetchFees();
      } else {
        setMessage({ type: "error", text: data.message || "Eroare la salvare." });
      }
    } catch {
      setMessage({ type: "error", text: "Eroare de conexiune." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modern-fees-page">
      <header className="fees-header">
        <h1>Administrare taxe</h1>
        <p>Configurează taxele anuale pentru fiecare categorie.</p>
      </header>
{/* === TAXE EXISTENTE === */}
      {fees.length > 0 && (
        <div className="fees-existing">
          <table>
            <thead>
              <tr>
                <th>An</th>
                <th>Copii</th>
                <th>16-64</th>
                <th>65+</th>
                <th>Arbitru 1</th>
                <th>Arbitru 2</th>
                <th>Arbitru 3</th>
                <th>Antrenor</th>
              </tr>
            </thead>
            <tbody>
              {fees.map((fee) => (
                <tr key={fee.an}>
                  <td>{fee.an}</td>
                  <td>{fee.taxa_sportiv1} lei</td>
                  <td>{fee.taxa_sportiv2} lei</td>
                  <td>{fee.taxa_sportiv3} lei</td>
                  <td>{fee.taxa_arbitru1} lei</td>
                  <td>{fee.taxa_arbitru2} lei</td>
                  <td>{fee.taxa_arbitru3} lei</td>
                  <td>{fee.taxa_antrenor} lei</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <form className="glass-card" onSubmit={handleSubmit}>
        <div className="grid">
          <div className="field">
            <label>An</label>
            <input
              type="number"
              value={form.an}
              onChange={(e) => setForm({ ...form, an: e.target.value })}
            />
          </div>

          {[
            ["Sportiv copii", "taxa_sportiv1"],
            ["Sportiv 16–64", "taxa_sportiv2"],
            ["Sportiv 65+", "taxa_sportiv3"],
            ["Arbitru cat. 1", "taxa_arbitru1"],
            ["Arbitru cat. 2", "taxa_arbitru2"],
            ["Arbitru cat. 3", "taxa_arbitru3"],
            ["Antrenor", "taxa_antrenor"],
          ].map(([label, key]) => (
            <div className="field" key={key}>
              <label>{label}</label>
              <input
                type="number"
                placeholder="0 lei"
                value={form[key]}
                onChange={(e) => setForm({ ...form, [key]: e.target.value })}
              />
            </div>
          ))}
        </div>

        {message && (
          <div className={`toast ${message.type}`}>
            {message.type === "success" ? <CheckCircle /> : <AlertCircle />}
            <span>{message.text}</span>
          </div>
        )}

        <div className="footer-bar">
          <button className="submit-btn" disabled={loading}>
            {loading ? <Loader2 className="spin" /> : " Salvează"}
          </button>
        </div>
      </form>

  
    </div>
  );
}
